import { c as _c } from "react/compiler-runtime";
import FollowDialog, { FollowDialogType } from '@/components/FollowDialog';
import { useFollowData } from '@/hooks/useFollowData';
export default function FollowCountsDialogs() {
  const $ = _c(2);
  const followData = useFollowData();
  let t0;
  if ($[0] !== followData) {
    t0 = <><FollowDialog {...followData} dialogType={FollowDialogType.Followers} /><FollowDialog {...followData} dialogType={FollowDialogType.Followings} /></>;
    $[0] = followData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}